import React from 'react';
import { CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { checkoutUrl, mockupUrl, offerAnchor } from '../data/content';
import { checkoutFeatures, pricing } from '../data/bonuses';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
export function Pricing({
  id = 'offer'
}: {
  id?: string;
}) {
  const titleId = `${id}-title`;
  return <section id={id} className="scroll-mt-4 bg-blue-700 px-4 py-12 md:py-16" aria-labelledby={titleId} data-id="element-156" data-mp="fbb2qoh5qa2p">
      <div className="mx-auto max-w-xl" data-id="element-157" data-mp="kbfgi6qokqp8">
        <div className="text-center" data-id="element-158" data-mp="ka4fufsj7z2c">
          <p className="text-[11px] font-black uppercase tracking-[.2em] text-white/90 md:text-xs" data-id="element-159" data-mp="6beir05ppzdz">Special launch offer</p>
          <h2 id={titleId} className="mt-2 text-2xl font-black uppercase leading-tight text-white md:text-4xl" data-id="element-160" data-mp="abyf41igoyz2">
            Complete Sports Massage Bundle
          </h2>
          <p className="mx-auto mt-2 max-w-lg text-sm leading-relaxed text-white/90 md:text-base" data-id="element-161" data-mp="2v2yxcd8p7qic">
            The complete professional system for organized sports massage protocols, practical techniques, and
            ready-to-adapt sessions.
          </p>
        </div>

        <article className="mt-8 rounded-3xl bg-white p-6 shadow-2xl md:p-8" data-id="element-162" data-mp="2aqm16qui0wqp">
          <OfferLink href={offerAnchor} className="mx-auto max-w-[280px]" label="Complete Sports Massage Bundle offer" data-id="element-163" data-mp="2opu2pqe4wgy2">
            <img src={mockupUrl} alt="Complete Sports Massage Bundle 3D mockup" className="w-full object-contain transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-164" data-mp="2kos2p7ce80v1" />
          </OfferLink>

          <h3 className="mt-6 text-sm font-black uppercase tracking-wide text-blue-950" data-id="element-165" data-mp="38b89a5kxgw2k">5 Complete Volumes</h3>
          <h3 className="mt-2 text-sm font-black uppercase tracking-wide text-blue-950" data-id="element-166" data-mp="33ehwps8c0ilw">5 Practical Bonuses</h3>
          <p className="mt-3 flex items-center justify-between gap-4 text-sm" data-id="element-167" data-mp="3hd7rv2blc87m">
            <span className="font-semibold text-slate-600" data-id="element-168" data-mp="3cf67me2fi2uk">Bonus value</span>
            <span data-id="element-169" data-mp="2a18co90x163k">
              <span className="font-bold text-slate-500 line-through decoration-red-600 decoration-2" data-id="element-170" data-mp="2a1qhhu1n8sn3">
                ${pricing.bonusValue} USD
              </span>
              <span className="ml-2 font-black uppercase text-blue-700" data-id="element-171" data-mp="2j1dhqcimzsek">Free</span>
            </span>
          </p>

          <ul className="mt-6 space-y-2" data-id="element-172" data-mp="2ns3onu6po3bd">
            {checkoutFeatures.map(item => <li key={item} className="flex items-start gap-2 text-sm font-medium text-blue-950" data-id="element-173" data-mp="2srgcoi9bjgfj">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-blue-700" aria-hidden="true" data-id="element-174" data-mp="2xpi35o92qi11" />
                {item}
              </li>)}
          </ul>

          <div className="mt-8" data-id="element-175" data-mp="32n9yytcuaoai">
            <Button href={checkoutUrl} size="lg" fullWidth subtext="Instant Digital Delivery" data-id="element-176" data-mp="36qzih4enqfoo">
              Get instant access — ${pricing.price}
            </Button>
          </div>
          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2 text-[10px] font-extrabold uppercase text-slate-600" data-id="element-177" data-mp="1ccf04ydt6w8g">
            <li className="flex items-center gap-1.5" data-id="element-178" data-mp="14u7dw7zlfahh">
              <ZapIcon className="h-3.5 w-3.5 text-blue-700" aria-hidden="true" data-id="element-179" data-mp="102fq257tniv1" /> Instant Digital Delivery
            </li>
            <li className="flex items-center gap-1.5" data-id="element-180" data-mp="v2ul9e5z0gae">
              <ShieldCheckIcon className="h-3.5 w-3.5 text-blue-700" aria-hidden="true" data-id="element-181" data-mp="v19w642fdpjx" /> 7-Day Guarantee
            </li>
            <li className="flex items-center gap-1.5" data-id="element-182" data-mp="1ns1ourka7w2i">
              <LockIcon className="h-3.5 w-3.5 text-blue-700" aria-hidden="true" data-id="element-183" data-mp="1nri5d6ezgzmd" /> Secure Payment
            </li>
          </ul>
        </article>
      </div>
    </section>;
}